export default __webpack_public_path__ + "static/world-map-32123b3e4f9aeea781a8be24866c6d4f.svg";